import { Hero } from "@/components/home/Hero";
import { BrandMarquee } from "@/components/home/BrandMarquee";
import { Collections } from "@/components/home/Collections";
import { Featured } from "@/components/home/Featured";
import { BrandStory } from "@/components/home/BrandStory";
import { WhyNoora } from "@/components/home/WhyNoora";
import { LifestyleBanner } from "@/components/home/LifestyleBanner";
import { InstagramSection } from "@/components/home/InstagramSection";
import { Reviews } from "@/components/home/Reviews";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <BrandMarquee />
      <Collections />
      <Featured />
      <BrandStory />
      <WhyNoora />
      <LifestyleBanner />
      <Reviews />
      <InstagramSection />
    </div>
  );
}
